// Branded illustrations of the two FOFO franchise cart models.
// PLACEHOLDER ART: swap with real cart photography when the client provides it.

export const StandaloneCartIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 400 270" className={className} role="img" aria-label="Standalone kulfi cart illustration">
    <circle cx="200" cy="140" r="120" fill="#FFC533" opacity="0.14" />
    {/* umbrella */}
    <path d="M200 20 L80 84 L140 84 Z" fill="#E46A12" />
    <path d="M200 20 L140 84 L200 84 Z" fill="#FFC533" />
    <path d="M200 20 L200 84 L260 84 Z" fill="#D11B6B" />
    <path d="M200 20 L260 84 L320 84 Z" fill="#1F7A3A" />
    <circle cx="200" cy="18" r="6" fill="#D6A84A" />
    <rect x="197" y="84" width="6" height="52" rx="3" fill="#3B2416" />
    {/* counter + goodies */}
    <rect x="78" y="128" width="244" height="14" rx="7" fill="#D6A84A" />
    <circle cx="122" cy="116" r="15" fill="#E46A12" />
    <rect x="109" y="97" width="26" height="7" rx="3.5" fill="#3B2416" />
    <rect x="276" y="100" width="26" height="28" rx="5" fill="#1E4ED8" />
    <line x1="283" y1="102" x2="283" y2="88" stroke="#3B2416" strokeWidth="3" strokeLinecap="round" />
    <line x1="290" y1="102" x2="290" y2="84" stroke="#3B2416" strokeWidth="3" strokeLinecap="round" />
    <line x1="297" y1="102" x2="297" y2="90" stroke="#3B2416" strokeWidth="3" strokeLinecap="round" />
    {/* cart body */}
    <rect x="90" y="142" width="220" height="72" rx="12" fill="#B6452C" />
    <rect x="104" y="154" width="192" height="48" rx="8" fill="#FFF3D6" />
    <text x="200" y="176" textAnchor="middle" fontSize="19" fontWeight="700" fill="#B6452C" fontFamily="'Baloo 2', sans-serif">DESI MASTAANI</text>
    <text x="200" y="194" textAnchor="middle" fontSize="11" fontWeight="700" letterSpacing="3" fill="#D11B6B" fontFamily="'Baloo 2', sans-serif">MATKA KULFI</text>
    {/* wheels */}
    <circle cx="142" cy="230" r="22" fill="#3B2416" />
    <circle cx="142" cy="230" r="9" fill="#FFF3D6" />
    <circle cx="258" cy="230" r="22" fill="#3B2416" />
    <circle cx="258" cy="230" r="9" fill="#FFF3D6" />
    <line x1="60" y1="256" x2="340" y2="256" stroke="#D6A84A" strokeWidth="4" strokeLinecap="round" strokeDasharray="2 14" />
  </svg>
);

export const EVCartIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 400 270" className={className} role="img" aria-label="EV kulfi cart illustration">
    <circle cx="210" cy="140" r="120" fill="#1F7A3A" opacity="0.10" />
    {/* motion lines */}
    <line x1="34" y1="130" x2="66" y2="130" stroke="#1E4ED8" strokeWidth="5" strokeLinecap="round" opacity="0.5" />
    <line x1="24" y1="150" x2="62" y2="150" stroke="#1E4ED8" strokeWidth="5" strokeLinecap="round" opacity="0.35" />
    <line x1="38" y1="170" x2="66" y2="170" stroke="#1E4ED8" strokeWidth="5" strokeLinecap="round" opacity="0.5" />
    {/* roof + cargo box */}
    <rect x="132" y="76" width="204" height="12" rx="6" fill="#D6A84A" />
    <rect x="140" y="88" width="190" height="100" rx="14" fill="#1F7A3A" />
    <rect x="156" y="104" width="158" height="68" rx="8" fill="#FFF3D6" />
    <text x="235" y="132" textAnchor="middle" fontSize="18" fontWeight="700" fill="#1F7A3A" fontFamily="'Baloo 2', sans-serif">DESI MASTAANI</text>
    <text x="235" y="152" textAnchor="middle" fontSize="11" fontWeight="700" letterSpacing="3" fill="#E46A12" fontFamily="'Baloo 2', sans-serif">EV KULFI CART</text>
    {/* cabin */}
    <path d="M140 188 L104 188 Q86 188 83 168 L78 130 Q77 118 89 118 L140 118 Z" fill="#E46A12" />
    <path d="M96 118 L88 92" stroke="#3B2416" strokeWidth="5" strokeLinecap="round" />
    <circle cx="86" cy="88" r="6" fill="#3B2416" />
    <rect x="90" y="130" width="34" height="22" rx="5" fill="#FFF3D6" opacity="0.9" />
    {/* battery bolt badge */}
    <circle cx="330" cy="80" r="21" fill="#FFC533" stroke="#3B2416" strokeWidth="3" />
    <path d="M332 66 L320 84 L328 84 L326 96 L340 78 L331 78 Z" fill="#3B2416" />
    {/* wheels */}
    <circle cx="102" cy="212" r="20" fill="#3B2416" />
    <circle cx="102" cy="212" r="8" fill="#FFF3D6" />
    <circle cx="288" cy="212" r="20" fill="#3B2416" />
    <circle cx="288" cy="212" r="8" fill="#FFF3D6" />
    <line x1="50" y1="238" x2="350" y2="238" stroke="#D6A84A" strokeWidth="4" strokeLinecap="round" strokeDasharray="2 14" />
  </svg>
);
